export default function StreamInputDescRtmpPull({ input }) {
  return <>RTMP {input.url}</>;
}
